// All options / translations/ values that available for the query user groups

import {FilterOptions} from '@shared-types';
import {Cached} from '@utils';
import {UserGroupsSortType, UserGroupSortDirection} from '../types/user-group.types';

export type IUserGroupsData = {
	Sorting: {
		markers: Record<UserGroupsSortType, FilterOptions<UserGroupsSortType>>;
		directions: Record<UserGroupSortDirection, FilterOptions<UserGroupSortDirection>>;
	};
	Filters: {
		toggleLockedGroups: FilterOptions<boolean>;
	};
};

export class UserGroupsData {
	@Cached()
	static getQueryUserGroupsData(): IUserGroupsData {
		return {
			Sorting: {
				markers: {
					[UserGroupsSortType.Default]: {
						label: 'features.groups-management.sort-by.default',
						icon: 'fa-duotone fa-sort',
						isDefaultFilter: true,
						value: UserGroupsSortType.Default,
					},
					[UserGroupsSortType.Name]: {
						label: 'pages.groups.table.group-name',
						icon: 'fa-duotone fa-font',
						value: UserGroupsSortType.Name,
					},
					[UserGroupsSortType.UsersCount]: {
						label: 'pages.groups.table.users-number',
						icon: 'fa-duotone fa-users',
						value: UserGroupsSortType.UsersCount,
					},
				},
				directions: {
					[UserGroupSortDirection.Asc]: {
						label: 'features.groups-management.sort-by.name-asc',
						icon: 'fa-solid fa-arrow-up',
						value: UserGroupSortDirection.Asc,
					},
					[UserGroupSortDirection.Desc]: {
						label: 'features.groups-management.sort-by.name-desc',
						icon: 'fa-solid fa-arrow-down',
						value: UserGroupSortDirection.Desc,
						isDefaultFilter: true,
					},
				},
			},
			Filters: {
				toggleLockedGroups: {
					label: 'features.groups-management.show-locked-groups',
					icon: 'fa-duotone fa-lock',
					value: false, // not visible by default
				},
			},
		};
	}
}
